/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_AbstractInputs */

const en_read_along_abstract = /** @type {(inputs: Read_Along_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstract`)
};

const es_read_along_abstract = /** @type {(inputs: Read_Along_AbstractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

/**
* | output |
* | --- |
* | "Abstract" |
*
* @param {Read_Along_AbstractInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_abstract = /** @type {((inputs?: Read_Along_AbstractInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_AbstractInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_abstract(inputs)
	return en_read_along_abstract(inputs)
});